import { Outlet, NavLink } from 'react-router-dom';
import { Box, Typography, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import { useTranslation } from 'react-i18next';

const linkSx = (active: boolean) => ({
  bgcolor: active ? 'action.selected' : 'transparent',
  color: active ? 'primary.main' : 'text.primary',
  '& .MuiListItemIcon-root': { color: active ? 'primary.main' : 'inherit' },
});

export default function CentrosReportsLayout() {
  const { t } = useTranslation<'translation'>();

  return (
    <Box sx={{ display: 'flex', minHeight: '100%' }}>
      <Box
        sx={{
          width: 220,
          borderRight: 1,
          borderColor: 'divider',
          px: 2,
          py: 3,
        }}
      >
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t('centrosReportsLayout.titulo')}
        </Typography>

        <List dense disablePadding>
          <NavLink to="ocupacion">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <MeetingRoomIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('centrosReportsLayout.menu.ocupacion')} />
              </ListItemButton>
            )}
          </NavLink>
        </List>
      </Box>

      <Box sx={{ flex: 1, p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
